import { render, staticRenderFns } from "./PagoForm.vue?vue&type=template&id=ab22a060&scoped=true&"
import script from "./PagoForm.vue?vue&type=script&lang=js&"
export * from "./PagoForm.vue?vue&type=script&lang=js&"
import style0 from "./PagoForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PagoForm.vue?vue&type=style&index=1&id=ab22a060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab22a060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
